import React from 'react';
import { Lang } from '../../utils/configure';
export const LocaleContext = React.createContext({ lang: Lang.Ru, tld: '.ru' });
